module.exports = __webpack_public_path__ + "static/media/49.ab795403.jpg";